import { lazy } from "react";
import Loadable from "components/Loadable";

// Lazy-loaded components
const List = Loadable(lazy(() => import("pages/standards/molecules/List")));

const RecordRoute = [
  {
    path: "record",
    children: [
      {
        path: "view",
        element: (
          <List
            moduleType="record"
            limit={30}
            name="Records"
            isRecord={true}
            isFormat={true}
            navigateUrl="format-detail"
          />
        )
      }
    ]
  }
];

export default RecordRoute;
